const API_CONFIG = {
  baseURL: process.env.REACT_APP_API_URL || 
    (process.env.NODE_ENV === 'development' 
      ? 'http://api.sportplatzgarage.xx/' 
      : 'https://api.sportplatzgarage.ch/')
};

export default API_CONFIG;

